import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import {
  PacketModalShell,
  modalGhostButtonStyle,
  modalInputStyle,
  modalPrimaryButtonStyle,
} from '../components/PacketModalShell'
import { dark, type as typo } from '../tokens'

type Props = {
  adName: string
  onCreate: (label: string) => void
  onClose: () => void
}

/**
 * Names a theme being created from an ad's Theme menu. Portaled because the
 * shell positions itself `fixed`, and the ad card it opens from is transformed
 * on hover, which would pin the overlay to the card instead of the viewport.
 */
export function NewThemeDialog({ adName, onCreate, onClose }: Props) {
  const [label, setLabel] = useState('')
  const trimmed = label.trim()

  const submit = (event: React.FormEvent) => {
    event.preventDefault()
    if (!trimmed) return
    onCreate(trimmed)
    onClose()
  }

  return createPortal(
    <PacketModalShell palette={dark} title="New theme" onClose={onClose}>
      <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <p style={{ margin: 0, fontSize: typo.size.body, color: dark.textMuted }}>
          “{adName}” will move into it.
        </p>
        <input
          autoFocus
          aria-label="Theme name"
          placeholder="Theme name"
          maxLength={120}
          value={label}
          onChange={event => setLabel(event.target.value)}
          style={modalInputStyle(dark)}
        />
        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" onClick={onClose} style={modalGhostButtonStyle(dark)}>
            Cancel
          </button>
          <button
            type="submit"
            disabled={!trimmed}
            style={{ ...modalPrimaryButtonStyle(dark), opacity: trimmed ? 1 : 0.5 }}
          >
            Create theme
          </button>
        </div>
      </form>
    </PacketModalShell>,
    document.body
  )
}
